$( document ).ready(function() {
  $(document).on('change', '.js-open-checkbox', function(e) {
    $('.js-amout-plan-order').toggleClass('none')
  });
});
